var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"input",attrs:{"autofocus":"","type":"text"},domProps:{"value":_vm.value},on:{"input":_vm.handleInput,"invalid":function($event){return _vm.$emit('invalid', $event)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;$event.preventDefault();}}})
}
var staticRenderFns = []

export { render, staticRenderFns }